import * as React from 'react';
import { useTranslation } from 'react-i18next';
import {
  CheckboxVisibility,
  DatePicker,
  DefaultButton,
  defaultDatePickerStrings,
  IColumn,
  Link,
  Modal,
  PrimaryButton,
  MessageBarType,
  MessageBar,
  IconButton,
  Dropdown,
  SearchBox,
  Label,
  Tooltip,
  TooltipHost,
  DirectionalHint,
} from '@fluentui/react';
import { IObjectWithKey, Selection } from '@fluentui/react/lib/DetailsList';
import * as Api from '../../../api/src';
import ModalHeader from '../../../control/modalHeader';
import { NoDataFound } from '../../../control/noDataFound';
import Moment from 'moment';
import { TeuDetailsList } from '../../../control/detailList';
export interface ModalUpdateDeadlineProps {
  IsOpen: boolean;
  onCloseModal: () => void;
  onSaveClick?: () => void;
  ProductTypeId: number;
  Year: number;
}
const MatrixApi = new Api.MatrixsApi();
const VendorsApi = new Api.VendorsApi();

let _selectionModules: Selection | undefined = new Selection();
const ModalUpdateDeadline = ({ IsOpen, onCloseModal, onSaveClick, ProductTypeId, Year }: ModalUpdateDeadlineProps) => {
  const { t } = useTranslation();
  const [isShow, SetIsShow] = React.useState(false);
  const [showModuleError, SetShowModuleError] = React.useState(false);
  const [listVendor, setListVendor] = React.useState<any[]>([]);
  const [_columnsModule, setColumnsModule] = React.useState<IColumn[]>([] as IColumn[]);
  const [FilterQuery, setFilterQuery] = React.useState<any>({
    ProductTypeId: ProductTypeId,
    Year: Year,
    ProductName: '',
    VendorId: 0,
  });
  let FilterQueryCache = React.useRef<any>({
    ProductTypeId: ProductTypeId,
    Year: Year,
    ProductName: '',
    VendorId: 0,
  });
  let timeOut = React.useRef<any | null>();
  let listModules = React.useRef<any>();
  let _columnsModuleCache = React.useRef<IColumn[]>([]);
  React.useEffect(() => {
    if (timeOut.current) {
      clearTimeout(timeOut.current);
    }
    if (FilterQuery.ProductName !== FilterQueryCache.current.ProductName) {
      timeOut.current = setTimeout(() => {
        getModules();
      }, 500);
    } else {
      getModules();
    }
    FilterQueryCache.current = FilterQuery;
  }, [FilterQuery]);
  React.useEffect(() => {
    SetIsShow(IsOpen);
    if (IsOpen) {
      getModules();
      getAllVendors(ProductTypeId);
    }
  }, [IsOpen]);
  const getAllVendors = async (ProductTypeId: number) => {
    if (ProductTypeId === 0) {
      setListVendor([]);
      return;
    }
    let data = (
      await VendorsApi.apiVendorsPagedPost({
        PageNumber: 1,
        OrderBy: [{ ColumnName: 'Name' }],
        PageSize: 0,
        SearchString: '',
        GetOnlyActive: true,
        ProductTypeId: ProductTypeId,
      })
    ).data;
    let vendors: any[] = [{ key: 0, text: t('AllVendors') }];
    data.Data?.forEach((element) => {
      vendors.push({ key: element.Id, text: element.Name });
    });
    setListVendor(vendors);
  };
  const getModules = async () => {
    // let data = (await MatrixApi.apiMatrixsGetProductModulesPost(FilterQuery)).data;
    let data: any;
    listModules.current = data.Data;
    var column = [
      {
        key: 'ProductName',
        name: t('ProductName'),
        fieldName: 'Name',
        className: 'flex-center',
        isResizable: true,
        minWidth: 250,
      },
    ] as IColumn[];
    // data.Data?.Modules?.forEach((o, i) => {
    //   column.push({
    //     key: (o.Id || 0).toString() || '',
    //     name: o.Name || '',
    //     fieldName: 'Deadline',
    //     className: 'flex-center',
    //     isResizable: true,
    //     minWidth: 250,
    //     onRender: (item: Api.Product, index, column) => {
    //       var itemProductModules = listModules.current?.ProductModules?.find(
    //         (o) => o.ProductId === item.Id && column?.key === o.ModuleId?.toString(),
    //       );
    //       if (itemProductModules) {
    //         return (
    //           <>
    //             <DatePicker
    //               style={{ height: 32 }}
    //               showWeekNumbers={true}
    //               firstWeekOfYear={1}
    //               showMonthPickerAsOverlay={true}
    //               value={itemProductModules.Deadline ? Moment(itemProductModules.Deadline).toDate() : undefined}
    //               placeholder="dd/mm/yyyy"
    //               formatDate={(date?: Date): string => {
    //                 return Moment(date).format('DD/MM/yyyy');
    //               }}
    //               onSelectDate={(date: Date | null | undefined) => {
    //                 if (itemProductModules) {
    //                   itemProductModules.Deadline = Moment(date).format('MM/DD/yyyy') || undefined;
    //                   if (listModules.current) {
    //                     listModules.current.ProductModules = [
    //                       ...(listModules.current?.ProductModules?.filter((o) => o !== !itemProductModules) || []),
    //                       ...[itemProductModules],
    //                     ];
    //                   }
    //                 }
    //               }}
    //               strings={defaultDatePickerStrings}
    //             />
    //             <TooltipHost content={t('CopyToBelow')} directionalHint={DirectionalHint.rightCenter}>
    //               <IconButton
    //                 iconProps={{ iconName: 'Down' }}
    //                 onClick={() => {
    //                   if (!itemProductModules?.Deadline) return;
    //                   var datas = listModules.current?.ProductModules?.filter(
    //                     (o) => column?.key === o.ModuleId?.toString(),
    //                   );
    //                   var isProducts: any = [];
    //                   listModules.current?.Products?.forEach((o, i) => {
    //                     if (i > (index || 0)) {
    //                       isProducts.push(o.Id);
    //                     }
    //                   });
    //                   datas?.forEach((e, i) => {
    //                     if (isProducts.indexOf(e.ProductId) >= 0) {
    //                       e.Deadline = itemProductModules?.Deadline;
    //                     }
    //                   });
    //                   setColumnsModule([..._columnsModuleCache.current]);
    //                 }}
    //               ></IconButton>
    //             </TooltipHost>
    //           </>
    //         );
    //       } else {
    //         return '-';
    //       }
    //     },
    //   });
    // });
    setColumnsModule([...column]);
    _columnsModuleCache.current = column;
  };
  const getTitle = (): string => {
    return t('UpdateDeadlines');
  };
  const onClose = () => {
    onCloseModal();
    SetIsShow(false);
  };
  const onSave = async () => {
    // var dataCheckeds = listModules.current?.Products?.filter((o: any) => o.checked === true);
    // var itemModuleUpdate: Api.ProductModule[] = [];
    // if (dataCheckeds) {
    //   dataCheckeds.forEach((element) => {
    //     var data = listModules.current?.ProductModules?.filter(
    //       (o) => o.ProductId === element.Id && o.Deadline !== undefined && o.Deadline !== null,
    //     );
    //     itemModuleUpdate = [...itemModuleUpdate, ...(data || [])];
    //   });
    // }
    // if (itemModuleUpdate?.length <= 0) {
    //   SetShowModuleError(true);
    //   return;
    // }
    // MatrixApi.apiMatrixsUpdateDeadlineMultiplePost({ ProductModules: itemModuleUpdate });
    // onCloseModal();
    // SetIsShow(false);
  };
  return (
    <Modal isOpen={isShow} isModeless={true}>
      <ModalHeader
        title={getTitle()}
        onCloseModal={() => {
          onClose();
        }}
      />
      <div className={'modal-content  ms-Grid'} style={{ width: 1200 }} dir="ltr">
        {showModuleError && (
          <MessageBar messageBarType={MessageBarType.error} isMultiline={false} dismissButtonAriaLabel="Close">
            {t('PleaseSelectProduct')}
          </MessageBar>
        )}
        <div className="ms-Grid-row">
          <div className="ms-md12  ms-Grid-col">{t('PleaseSelectProductsFromTheListForUpdating')}</div>
        </div>
        <div className="ms-Grid-row">
          <div className="ms-md4  ms-Grid-col">
            <Dropdown
              options={listVendor}
              label={t('Vendor')}
              selectedKey={FilterQuery?.VendorId}
              onChange={(e, opt, index) => {
                setFilterQuery({ ...FilterQuery, VendorId: parseInt((opt?.key || 0).toString()) });
              }}
            ></Dropdown>
          </div>
          <div className="ms-md4 ms-Grid-col">
            <Label>&nbsp;</Label>
            <SearchBox
              placeholder={t('ProductName')}
              value={FilterQuery.ProductName || ''}
              showIcon={true}
              onChange={(e, newValue) => {
                setFilterQuery({ ...FilterQuery, ProductName: newValue || '' });
              }}
            />
          </div>
        </div>
        <div className="ms-Grid-row">
          {(listModules?.current?.Products?.length || 0) > 0 && (
            <TeuDetailsList
              props={{
                styles: { root: { minHeight: 600 } },
                items: listModules.current?.Products || [],
                columns: _columnsModule,
                compact: true,
                checkboxVisibility: CheckboxVisibility.always,
              }}
            />
          )}
          <NoDataFound isShow={(listModules?.current?.Products?.length || 0) === 0}></NoDataFound>
        </div>
      </div>
      <div className={'modal-footer'}>
        <DefaultButton
          className={'margin-left-10'}
          onClick={() => {
            onClose();
          }}
        >
          {t('Close')}
        </DefaultButton>
        <PrimaryButton
          className={'margin-left-10'}
          disabled={false}
          onClick={() => {
            onSave();
          }}
        >
          {t('Save')}
        </PrimaryButton>
      </div>
    </Modal>
  );
};
export default ModalUpdateDeadline;
